<template>
  <div class="p-postEditor__itemWrapper">
    <div v-show="editingItemIndex !== index" @click="editItem">
      <character-item-preview :item="item" />
    </div>
    <item-form v-if="editingItemIndex === index" :item="item">
      <v-row>
        <v-col lg="3" class="text-center">
          <div class="mb-6">
            <div>
              <v-avatar v-if="editingItemable.characterImage" size="80">
                <img :src="editingItemable.characterImage.avatar.thumb.url" />
              </v-avatar>
              <v-avatar v-else color="grey lighten-1" size="80" />
            </div>
            <v-btn
              color="primary"
              class="mt-3 d-inline-block"
              outlined
              x-small
              tile
              @click="selectCharacters"
            >
              キャラを選択
            </v-btn>
            <v-btn
              v-if="currentUser.isAdmin"
              color="primary"
              class="mt-3 d-inline-block"
              outlined
              x-small
              tile
              @click="newCharacter"
            >
              キャラを作成
            </v-btn>
          </div>

          <v-select
            :value="editingItemable.imageSide"
            :items="imageSides"
            class="body-2 pa-2"
            label="画像表示位置"
            item-text="text"
            item-value="value"
            dense
            @change="updateEditingItemable($event, 'imageSide')"
          />
        </v-col>
        <v-col lg="9">
          <v-textarea
            :value="editingItemable.content"
            class="body-2"
            label="セリフコンテンツ"
            autofocus
            :rules="[presenceValidation]"
            @input="(value) => updateEditingItemable(value, 'content')"
          />
        </v-col>
      </v-row>
    </item-form>

    <v-dialog v-model="selectCharactersDialog" width="500">
      <v-card>
        <v-card-title> キャラクター一覧 </v-card-title>
        <v-card-text>
          <v-row>
            <v-col
              v-for="character in characters"
              :key="character.id"
              lg="4"
              md="4"
              sm="6"
            >
              <v-card outlined class="ma-2">
                <v-card-text class="text-center">
                  <v-avatar size="64">
                    <img :src="character.avatar.thumb.url" />
                  </v-avatar>
                  <div class="my-2">
                    {{ character.name }}
                  </div>
                  <v-btn
                    outlined
                    tile
                    small
                    color="success"
                    @click="selectCharacter(character)"
                  >
                    選択
                  </v-btn>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <CharacterForm
      :dialog="newCharacterDialog"
      :character="character"
      @create-character="createCharacter"
      @close-new-character-dialog="closeNewCharacterDialog"
    ></CharacterForm>
  </div>
</template>

<script>
import itemUtilsMixin from '@/mixins/item_utils'
import imageUtilsMixin from '@/mixins/image_utils'
import axios from 'axios'
import CharacterItemPreview from './previews/CharacterItemPreview'
import CharacterForm from '@/pages/admin/characters/form.vue'
import { mapState } from 'vuex'
import formValidationUtils from '@/mixins/form_validation_utils'

export default {
  components: { CharacterItemPreview, CharacterForm },
  mixins: [itemUtilsMixin, imageUtilsMixin, formValidationUtils],
  data: () => {
    return {
      imageSides: [
        { text: '左', value: 'left' },
        { text: '右', value: 'right' }
      ],
      selectCharactersDialog: false,
      newCharacterDialog: false,
      characters: [],
      character: {
        id: null,
        name: null,
        avatar: null
      }
    }
  },
  computed: {
    content: function () {
      return this.item.itemableAttributes.content
    },
    ...mapState({
      currentUser: (state) => state.UserStore.currentUser
    })
  },
  methods: {
    closeNewCharacterDialog () {
      this.newCharacterDialog = false
    },
    selectCharacters () {
      if (this.characters.length === 0) {
        axios.get('/api/character_images').then(({ data }) => {
          const fetchedCharacters = data.data
          for (const i in fetchedCharacters) {
            const character = fetchedCharacters[i].attributes
            this.characters.push(character)
          }
        })
      }
      this.selectCharactersDialog = true
    },
    selectCharacter (character) {
      let itemable = Object.assign({}, this.editingItemable)
      itemable.characterImageId = character.id
      itemable.characterImage = character
      this.$store.commit('PostEditor/UPDATE_EDITING_ITEMABLE', itemable)
      this.closeNewCharacterDialog()
      this.selectCharactersDialog = false
    },
    newCharacter () {
      this.character = {
        id: null,
        name: null,
        avatar: null
      }
      this.newCharacterDialog = true
    },
    createCharacter () {
      this.$store.dispatch('LoaderStore/displayLoader')
      const payload = this.character
      let formData = new FormData()
      formData.append('character_image[name]', payload.name || '')
      formData.append('character_image[avatar]', payload.avatar)
      axios
        .post('/api/character_images', formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        })
        .then(
          ({ data }) => {
            const character = data.data.attributes
            let itemable = Object.assign({}, this.editingItemable)
            itemable.characterImageId = character.id
            itemable.characterImage = character
            this.$store.commit('PostEditor/UPDATE_EDITING_ITEMABLE', itemable)
            this.$store.dispatch('LoaderStore/hideLoader')
            const payload = {
              status: 200,
              message: 'キャラクターを作成しました'
            }
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
            this.newCharacterDialog = false
          },
          (error) => {
            this.$store.dispatch('LoaderStore/hideLoader')
            const payload = {
              status: error.response.status,
              message: error.response.data.errors.toString()
            }
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
          }
        )
    }
  }
}
</script>

<style scoped></style>
